import React, { memo, useMemo } from 'react';
import { Typography } from 'antd';

const { Link } = Typography;

interface Props {
	taskId: number;
	extraData?: Record<string, any>;
}

const getDivider = (index: number, itemsLength: number) => {
	return index + 1 !== itemsLength ? <span className="divider">, </span> : null;
};

function TaskIdsCell({ taskId, extraData }: Props) {
	const idsToRender: Array<number | string> = useMemo(() => {
		return extraData?.task_ids?.length ? extraData.task_ids : [taskId];
	}, [taskId, extraData]);

	return (
		<>
			{idsToRender.map((extraTaskId, i) => {
				return (
					<span key={`task-ids-cell-${extraTaskId}`}>
						<Link
							href={`#/history/${extraTaskId}`}
							title={String(extraTaskId)}
							target="_blank"
							rel="noopener noreferrer"
						>
							{extraTaskId}
						</Link>
						{idsToRender.length > 1 && getDivider(i, idsToRender.length)}
					</span>
				);
			})}
		</>
	);
}

export default memo(TaskIdsCell);
